// Khởi tạo SDK Facebook
window.fbAsyncInit = function() {
FB.init({
    appId: "943647687395126",
    cookie: true,
    xfbml: true,
    version: "v19.0"
});
};

// Tải SDK Facebook
(function(d, s, id){
var js,
    fjs = d.getElementsByTagName(s)[0];
if (d.getElementById(id)) {
    return;
}
js = d.createElement(s);
js.id = id;
js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));